import { FormGroup, FormControl, AbstractControl } from '@angular/forms';

export function markAllAsUntouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);
        if (control instanceof FormControl) {
            control.markAsUntouched();
        }
    });
}

export function markAllAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);
        if (control instanceof FormControl) {
            control.markAsTouched();
        }
    });
}

export function markAllAsValid(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);
        if (control instanceof FormControl) {
            control.setErrors(null);

        }
    });
}

export function updateValueAndValidity(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);
        if (control instanceof FormControl) {
            control.updateValueAndValidity();
        }
    });
}

export function generateRandom(num: number): any[] {
    const random = [];
    for (let i = 0; i < num; i++) {
        random.push('_' + Math.random().toString(36).substr(2, 9));
    }
    return random;
}

export const capitalize = (s) => {
    if (typeof s !== 'string') {
        return '';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
};

export function getLabelFromOptions(value: string, options): string {
    return options.forEach(el => {
        if (el.value === value) {
            return el.label;
        }
    });
}

export function isNullOrEmpty(str: string): boolean {
    return (str === undefined || str === '' || str === null);
}

export function getFirstProperty(obj: any) {
    let restituito = false;
    for (const prop in obj) {
        if (!restituito) {
            restituito = true;
            return obj[prop];
        }
    }
}

export function eliminaTokenAndRedirectLogin(tokenService, userService, patientService, router) {
    tokenService.deleteToken();
    userService.deleteUser();
    patientService.resetPatient();
    router.navigate(['/login']);
}

export function getAge(patient) {
    const nascitaPaziente = new Date(patient.birthDate);
    const today = new Date();
    let diff = Math.abs(today.getTime() - nascitaPaziente.getTime());
    return Math.floor((diff / (1000 * 3600 * 24)) / 365.25);
}

export function getDayName(dayNumber) {
    let dayNames = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
    return dayNames[dayNumber];
}

export function getDayNumberByShortName(name) {
    let dayShortNames = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
    return dayShortNames.indexOf(name);
}

export function addPaddingToArray(elements: any[]): any[] {
    for (let k in elements) {
        let element = elements[k];
        if (element.toLowerCase() != 'na' && Number(element) < 10) {
            elements[k] = "0" + Number(element);
        }
    }
    return elements;
}

// Custom validator
export function requiredFalse(control: AbstractControl) {
    if (control.value != undefined && control.value != "false" && control.value != false) {
        return { invalidValue: true };
    }
    return null;
}

export function invalidField(invalidTextReason, field?) {
    if (invalidTextReason) {
        switch (invalidTextReason) {
            case 'empty':
                return 'Il campo ' + field + ' non può essere vuoto.';
            case 'dropdown':
                return 'È richiesta una selezione nel campo ' + field + '.';
            case 'check':
                return 'È necessario spuntare ';
            case 'date':
                return 'La data ' + field + ' è richiesta '
            case 'upperCase':
                return 'il campo non può contenere caratteri in maiuscolo.';
            case 'lowerCase':
                return 'il campo non può contenere caratteri in minuscolo.';
            case 'nospace':
                return 'il campo non può contenere spazi.';
            case 'nospecial':
                return 'il campo non può contenere caratteri speciali.';
            case 'nospace-nospecial':
                return 'il campo non può contenere spazi, caratteri in maiuscolo o speciali.';
            default:
                return invalidTextReason;
        }
    }
    return 'campo non valido';
}

export function rimuoviDuplicatiDaArray(array) {
    return array.filter((el, i, a) => i === a.indexOf(el))
}

export function addPaddingToNumber(n) {
    if (Number(n) < 10) {
        return "0" + n;
    }
    return n;
}